import React, { useEffect, useRef, useState } from 'react';
// import MenuItem from '../components/MenuItem';
import { NavLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import '../App.css';

import Auth from '../core/services/auth';
import ReactTimeAgo from 'react-time-ago'
import Avatar from 'react-avatar';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import _ from 'lodash';


import { TECarousel, TECarouselItem } from "tw-elements-react";


import handleViewport, { type InjectedViewportProps } from 'react-in-viewport';
// import IconBackComponent from '../components/IconBackComponent';

const Block = (props: InjectedViewportProps<HTMLDivElement>) => {
  const { forwardedRef } = props;
//   inViewport
//   const color = inViewport ? '#217ac0' : '#ff9800';
//   const text = inViewport ? 'In viewport' : 'Not in viewport';
  return (
    <div onDoubleClick={e=>e.preventDefault()}  className=" inset-x-0 bottom-0" ref={forwardedRef}>
      {/* <h3>{ text }</h3> */}
      {/* <div style={{ width: '400px', height: '300px', background: color }} /> */}
    </div>
  );
};

const ViewportBlock = handleViewport(Block, /** options: {}, config: {} **/);

function Story() {
    const navigate = useNavigate()
    const { state } = useLocation();
    const { data } = state;
    const ref = useRef<any>();

    const [ story, setStory ] = useState(data ? data : {
                          vendor: [],
                          stories: [],
                          allStories: []
                    })

    console.log(story)

    
    const [ mute, setMute ] = useState(Auth.getMuted() !== "undefined" ? Auth.getMuted() === 'true' ? true : false : false)

    const unMute = () => {
      //
      if (mute) {
        setMute(false)

        Auth.setMuted('false')
      } else {
        setMute(true)
        Auth.setMuted('true')
      }
    }

    // const sharePost = async (id: string, caption: string) => {

    //   if (_.isEmpty(Auth.getUser())) {
    //     navigate('/login')
    //     return;
    //   } 

    //   const shareData = {
    //     title: `Wherespoppin - ${caption}`,
    //     text: `${caption}`,
    //     url: `https://wherespoppin.app/story/${id}`,
    //   };
    //   //
    //   await navigator.share(shareData);
    // }

    const [ open, setOpen ] = useState(false)


    const deleteStory = (id: any) => {
      
      if (_.isEmpty(Auth.getUser())) {
        navigate('/login')
        return;
      } 

      Auth.api.delete("/stories/"+id).then(res=>{

        // toast.success(res.data.message, {
        //   position: "top-center",
        // });
        
        // console.log(res.data.data)
        navigate(-1)


      }).catch(err=>{
        
          console.log(err)
        
          // toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
          //   position: "top-center",
          // });
      })
    }

    const viewStory = (id: any) => {
      
      if (_.isEmpty(Auth.getUser())) {
        navigate('/login')
        return;
      }

      Auth.api.get("/stories/viewed/"+id).then(res=>{

        // toast.success(res.data.message, {
        //   position: "top-center",
        // });
        
        // console.log(res.data.data)
        // navigate(-1)


      }).catch(err=>{
        
          console.log(err)
        
          // toast.error(err.response.data.error ? err.response.data.error.message : err.message, {
          //   position: "top-center",
          // });
      })
    }
    
    const params = useParams()

    useEffect(()=>{

      if (!state &&  !_.isEmpty(params) ) {
        //
        Auth.api.get('/stories/'+params.id).then(res=>{
          //
          setStory(res.data.data)
          console.log(res.data.data)
        })
  
      } 
      else if (state) {

      }
      else {
        //
        navigate('/')
        return;
      }

    }, [navigate, params, setStory, state])


    const _stories = story.allStories.length > 0 ? story.allStories : []

    const back = () => {
      navigate(-1)
    }
    // const storyItems = 

    return (
        <section className='h-screen bg-gray-800'>
          {/* <IconBackComponent /> */}
          
          <div className='absolute top-0 z-40 p-5'>
              <div  style={{width:'40px', height: '40px'}} className="flex items-center text-white justify-center bg-black/80 mx-auto rounded-full">
                  <button onClick={e=>back()} className="items-center">
                  <svg className="w-5 h-5" fill='currentColor' aria-hidden="true" viewBox="0 0 24 24"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"></path></svg>
                  </button>
              </div>
          </div>

          <TECarousel showControls interval={10000} ride="carousel">
          {
            _stories.map(
              // _story => <StoryComponent story={_story} />
              // _story => <li> {_story.caption} </li>
              (_story:any, index: any) => 
                    
                          <div key={index} className="relative w-full overflow-hidden after:clear-both after:block after:content-['']">
                           
                          {
                          _story.stories.map(
                                  ((_each: any, _index: any) => 
                                    <TECarouselItem
                                       
                                      itemID={_index+1}
                                      className="relative float-left -mr-[100%] hidden w-full transition-transform duration-[600ms] ease-in-out motion-reduce:transition-none"
                                    >
                                      
                                    {
                                    _each.media.type === 'image' ?
                                          
                                          <img alt={_each.caption} className='h-screen object-cover' src={_each.media.url}/>
                                      :
                                         ( _each.media.type === 'video' ?
                                          
                                          
                                          <video onClick={e=> unMute()} id={'svid'+_each._id} ref={ref}  playsInline={true} loop muted={mute} className="h-screen object-cover"> 
                                              <source src={_each.media.url+'#t=0.001'} type='video/mp4'></source>
                                          </video>
                                      :
                                      '') 
                                      }
      
                                      <div style={{marginLeft:'-15px'}} className=' '>
                                        <ViewportBlock onEnterViewport={() =>{ (document.getElementById('svid'+_each._id) as HTMLVideoElement)?.play();viewStory(_each._id) }} onLeaveViewport={() => { (document.getElementById('svid'+_each._id) as HTMLVideoElement)?.pause() }} />
                                      </div>

                                      {_each.vendor.userId === Auth.getUser()._id &&
                                        <div className='absolute right-5 top-5 space-y-1 flex flex-col mb-5 z-40'>

                                          <button onClick={e=> deleteStory(_each._id)}>
                                            <div style={{width:'40px', height: '40px'}} className="flex items-center text-white justify-center bg-black/80 mx-auto rounded-full">
                                            <svg fill='currentColor' className="w-5 h-5" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="DeleteIcon"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"></path></svg>

                                            </div>
                                          </button>
                                        </div>
                                      }
                                    </TECarouselItem>
      
      
                              )
                            )
                          }

                              <div className='flex flex-col absolute bottom-9 space-y-2 left-6 z-40'>
                                        <div className='flex flex-row items-center space-y-1 relative'>
                                          <NavLink to={Auth.getVendor().find((e: { name: any; })=>e.name === _story.vendor.name) ? '/vendor' : '/vendor-profile'} state={{name: _story.vendor.name, id: _story.stories[0].vendor._id}}>
                                              {(_story.stories[0].vendor.logo) &&
                                                                        
                                              <div style={{width:'55px', height: '55px'}} className="border bg-gray-100 border-slate-400 rounded-full">
                                                  <div className="bg-white block rounded-full  hover:-rotate-6 transform transition">
                                                          <img alt='profile' className='rounded-full object-cover aspect-square p-0.5' src={_story.stories[0].vendor.logo.url}/>
                                                  </div>
                                              </div>
                                                                        
                                              }
                                              { !(_story.stories[0].vendor.logo) &&
                                                  <Avatar round={true} size='55' name={_story.vendor.name} />
                                              }
                                          </NavLink>
                                          <div className='ml-4 text-left  '>
                                              <h2 className='text-md font-bold mb-0 text-white pb-0'>{_story.vendor.name }</h2>
                                              <p className='text-sm text-gray-500 text-white mb-0 pb-0'>
                                                  <ReactTimeAgo date={new Date(_story.stories[0].createdAt)} locale="en" />
                                              </p>
                                          </div>
                                        </div>
                                    </div>
      
                          </div>
               
            )
          }
          </TECarousel>
         
            

          {/* <div onClick={e=>unMute()} className=""> */}
          {/* {story.media.type === 'image' ?
           
                <img alt={story.caption} className='h-screen object-cover' src={story.media.url}></img>
            :
                story.media.type === 'video' ?

                <video autoPlay={true} muted={mute} loop  style={{ objectFit: 'cover' }} className="h-screen object-cover"> 
                    <source src={story.media.url} type='video/mp4'></source>
                    <source src={story.media.url} type='video/ogg'></source>
                </video>
            :

            ''
          } */}
            
          {/* </div> */}
          <Dialog open={open} onClose={setOpen} className="relative z-30">
            <DialogBackdrop
              transition
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0">
                <DialogPanel
                  transition
                  className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                  <div className="w- text-gray-900 bg-white rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white p-6">
                     
                      {story.vendor.userId === Auth.getUser()._id ?
                        <button onClick={e=>deleteStory(story.id)} type="button" className="relative inline-flex items-center w-full px-4 py-2 font-medium text-red-500 rounded-t-lg  bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400 focus:text-gray-400  dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                          <svg className="h-5 w-5 mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="DeleteIcon"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"></path></svg>
                          {/* <svg className="h-5 w-5 mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ReportGmailerrorredIcon"><path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27zM19 14.9 14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1z"></path><path d="M11 7h2v6h-2zm0 8h2v2h-2z"></path></svg> */}
                                <p className='font-medium text-xs'>Delete story</p>
                                          
                        </button>
                        : ''
                      }
                      <button type="button" className="relative inline-flex items-center w-full px-4 py-2 font-medium text-red-500 rounded-b-lg bg-gray-100 hover:text-gray-400  focus:z-10 focus:ring-2 focus:ring-gray-400 focus:text-gray-400  dark:border-gray-600 dark:hover:bg-gray-600 dark:hover:text-white dark:focus:ring-gray-500 dark:focus:text-white">
                        
                        <svg className="h-5 w-5 mr-2" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="ReportGmailerrorredIcon"><path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27zM19 14.9 14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1z"></path><path d="M11 7h2v6h-2zm0 8h2v2h-2z"></path></svg>
                              <p className='font-medium text-xs'>Report post</p>
                                        
                      </button>
                  </div>
                </DialogPanel>
              </div>
            </div>
          </Dialog>
        </section>
    );
  }
  
  export default Story;
  

